/* src/app/private/components/analytics/lead-activity-chart/lead-activity-chart.component.scss */
.section {
  padding: 1rem;
}
.chart {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.title {
  font-weight: bold;
  font-size: 1.2rem;
}
.sub-title {
  font-size: 0.9rem;
  color: gray;
}
.dropdown {
  margin-left: auto;
}
canvas {
  margin-top: 10px;
}
.chart,
h4 {
  color: rgb(43, 208, 41);
  font-size: 15px;
  margin-top: 10px;
}
.chart h2 {
  font-size: 20px;
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 0;
  color: var(--bg);
}
.chart h4 {
  margin-left: 20px;
  margin-bottom: 2px;
  color: var(--dark-grey);
}
.graph_ {
  margin: 10px;
}
.section {
  background: #fff;
  padding: 15px;
  border-radius: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  height: auto !important;
}
.chart {
  padding: 5px;
  display: flex;
  flex-direction: row;
}
.circle_graph_right {
  display: flex;
  flex-direction: row;
  justify-content: CENTER;
  align-items: CENTER;
}
.h-social-img {
  display: flex;
  flex-direction: column;
  align-items: CENTER;
}
.h-social-img img {
  width: 24px;
}
.canvas {
  display: flex;
  flex-direction: column;
  margin-top: 9px;
  justify-content: center;
  margin-left: 17px;
}
.title {
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #0D4259;
  margin-top: -18px;
}
.sub-title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #767373;
  margin-top: 4px;
  margin-bottom: 14px;
}
@media (max-width: 1024px) {
  .section {
    overflow: auto;
  }
  .canvas {
    width: 400px;
  }
}
/*# sourceMappingURL=lead-activity-chart.component.css.map */
